import { Link } from 'react-router-dom';
import NavLinks from '@/components/ui/sidenav/nav-links';
import Logo from '@/assets/Logo';
import { PowerIcon } from '@heroicons/react/24/outline';
import { logout } from '@/firebase'; // Ensure this function works as expected in your setup

export default function SideNav() {
    const handleLogout = async () => {
        try {
            await logout();
            console.log('Successfully logged out');
        } catch (error) {
            console.error('Logout failed', error);
        }
    };

    return (
        <div className="flex h-full flex-col px-3 py-4 md:px-2">
            {/* Logo Section */}
            <Link
                className="mb-2 flex h-20 items-end justify-start rounded-md bg-purple-500 p-4 md:h-40"
                to="/panel"
            >
                <div className="w-32 text-white md:w-40">
                    <Logo
                        path="/logos/tulu-white.svg" // Update this path with the actual logo file path
                        styles={{}}
                    />
                </div>
            </Link>

            {/* Navigation Links and Logout Section */}
            <div className="flex grow flex-row justify-between space-x-2 md:flex-col md:space-x-0 md:space-y-2">
                <NavLinks />
                <div className="hidden h-auto w-full grow rounded-md bg-gray-50 md:block"></div>
                <button
                    onClick={handleLogout}
                    className="flex h-[48px] w-full grow items-center justify-center gap-2 rounded-md bg-gray-50 p-3 text-sm font-medium hover:bg-sky-100 hover:text-blue-600 md:flex-none md:justify-start md:p-2 md:px-3"
                >
                    <PowerIcon className="w-6" />
                    <div className="hidden md:block">Sign Out</div>
                </button>
            </div>
        </div>
    );
}
